import { selectRouterPathname } from '@noths/polaris-client-next-redux';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';

export const selectPageType = (state: ReduxApplicationState) => state.navigation.pageType;

export const selectPathname = (state: ReduxApplicationState) => state.navigation.pathname;

export const selectHash = (state: ReduxApplicationState) => state.navigation.hash;

/**
 * The current resolved URL path. The connected-next-router slice isn't populated
 * with the resolved path on the first client render — it reads as '' (or '/') —
 * so during that phase we fall back to the explicitly hydrated
 * `navigation.pathname`. This keeps path-derived output (taxonomy content
 * selection, SEO meta robots / canonical tags) identical to the server render
 * and avoids an SSR/client head mismatch.
 */
export const selectResolvedPathname = (state: ReduxApplicationState): string => {
  const routerPath = selectRouterPathname(state);
  const routerPathIsResolved = routerPath !== '' && routerPath !== '/';

  return !routerPathIsResolved && state.navigation?.pathname
    ? state.navigation.pathname
    : routerPath;
};
